(function(){
    angular.module('active-is-not-in-segment.dir', [])
        .directive('activeIsNotInSegment', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeIsNotInListSegment]);

    function activeIsNotInListSegment($rootScope, $compile, $templateCache,  helpers, canvasService ){
        return {
            scope: {},
            controller: ['$scope', function($scope){
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.getAPLSegments = () => {
                    if($scope.lists) {
                        $scope.listView = true;
                    } else {
                        canvasService
                            .getSegmentsById($scope.data.selectedList)
                            .success((res) => {
                                $scope.lists = res.Results;
                                $scope.listView = true;
                            });
                    }
                };

                $scope.getSelectedText = (desc) => {
                    if ($scope.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], false, $scope.segmentData);
                        }

                        return desc;
                    }
                };

                $scope.parseDescription = function(desc, selected) {
                    var textToParse = desc;

                    if (textToParse && typeof textToParse === 'object'){

                        var descriptionCheck = false;
                        for (var item in textToParse){
                            if(textToParse[item]) {

                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                var totalLists = $scope.data.selectedList.length;
                                textToParse = helpers.getContactListItem(textToParse[item], false, $scope.segmentData);

                                //One list selected and > 19
                                if ( totalLists === 1 && textToParse.length > 15) {
                                    textToParse = textToParse.slice(0, 15) + '...';
                                    //More than one selected
                                } else if (totalLists > 1) {
                                    textToParse = totalLists + " Lists Selected";
                                    //One selected but < 19
                                }  else if (totalLists === 1 && textToParse.length < 15) {
                                    textToParse = textToParse;
                                }
                            }
                        }
                        if(!descriptionCheck) {
                            textToParse = parseDescriptionHelper(selected);
                        }
                    } else {
                        textToParse = parseDescriptionHelper(selected);
                    }

                    return textToParse;
                };

                var parseDescriptionHelper = function (selected) {
                    $scope.descriptionEmpty = true;
                    return selected === "showSelectedList" ? "" : "Description";
                };
                //Show or hide menu on Element click
                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.listView = false;
                    } else {
                        $scope.displayList = false;
                    }
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function() {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function() {
                    if($scope.displayList || $scope.displaySubMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        }else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function() {
                    $scope.displayList = false;
                };

                $scope.description = '';
                $rootScope.$watch('segmentData', (list) => {
                    if(list && list.length) {
                        $scope.segmentData = list;
                        const desc = $scope.parseDescription($scope.data.selectedList, 'showDescription');

                        if(desc) {
                            $scope.description = desc;
                        }
                    }
                });
            }],
            link: function (scope, elem, attr) {
                if($rootScope.aElement) {
                    // bullet proving multiple targets
                    if(document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/conditions/active-not-in-segment');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.numbers = '0';

                    $rootScope.$watch('segmentData', function (newData) {
                        if (newData) {
                            scope.segmentData = $rootScope.segmentData;
                            scope.parseDescription(scope.data.selectedList, 'showSelectedList')
                        }
                    });

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function(evt, data) {
                        if(data) {
                            scope.numbers = data;
                        }
                    });
                }
            }
        };
    }
}());



// WEBPACK FOOTER //
// ./app/directives/canvas_active_directives/conditions/active-is-not-in-segment.js